import React, { createContext, useEffect, useState } from 'react';
import styles from './Layout.module.scss';

export enum Layouts {
    exploreMoreEvents = 'exploreMoreEvents',
    hierarchy = 'hierarchy',
}

export type LayoutType = {
    exploreMoreEvents: boolean;
};

export const LayoutContext = createContext<LayoutType | null>(null);

export const Layout: React.FC<LayoutType> = ({
    children,
    exploreMoreEvents,
}) => {
    const [layoutsToApply, setLayoutsToApply] = useState(styles.layout);

    useEffect(() => {
        const layouts = [styles.layout];

        if (exploreMoreEvents) {
            layouts.push(styles.exploreMoreEvents);
        }

        setLayoutsToApply(layouts.join(' '));
    }, [exploreMoreEvents]);

    return (
        <LayoutContext.Provider
            value={{
                exploreMoreEvents: exploreMoreEvents,
            }}
        >
            <div className={layoutsToApply}>{children}</div>
        </LayoutContext.Provider>
    );
};
